"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyUpdaterPatch = applyUpdaterPatch;
exports.collectLinkStatements = collectLinkStatements;
exports.collectLinkedNodeStatements = collectLinkedNodeStatements;
exports.collectNodeStatements = collectNodeStatements;
exports.findExistingNode = findExistingNode;
exports.replacePredicateStatements = replacePredicateStatements;
var _rdflib = require("rdflib");
var _texts = require("../../texts");
function normalizeNodeId(value) {
  return value.startsWith('_:') ? value.slice(2) : value;
}
function applyUpdaterPatch(store, deletions, insertions) {
  if (!store.updater) {
    throw new Error(_texts.updaterUnsupportedStoreErrorMessageText);
  }
  const safeDeletions = (deletions || []).filter(statement => {
    if (!statement || !statement.subject || !statement.predicate || !statement.object) return false;
    const graph = statement.why;
    return store.holds(statement.subject, statement.predicate, statement.object, graph);
  });
  const safeInsertions = (insertions || []).filter(statement => {
    return Boolean(statement && statement.subject && statement.predicate && statement.object);
  });
  if (safeDeletions.length === 0 && safeInsertions.length === 0) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    try {
      ;
      store.updater.update(safeDeletions, safeInsertions, (_uri, ok, message) => {
        if (ok === true) {
          resolve();
          return;
        }
        reject(new Error(message || _texts.fallbackSaveUpdatesErrorMessageText));
      });
    } catch (error) {
      reject(error instanceof Error ? error : new Error(String(error)));
    }
  });
}
function collectNodeStatements(store, node, doc) {
  return store.statementsMatching(node, null, null, doc);
}
function collectLinkStatements(store, subject, predicate, node, doc) {
  return store.statementsMatching(subject, predicate, node, doc);
}

/* The following helper was generated by AI Model: GPT-5.3-Codex.
   Prompt: 'do you see anything I can do differently in the mutation code so that it's not so verbose and possible reusable accross sections' */
function replacePredicateStatements(store, subject, predicate, doc, deletions, insertions, nextObject) {
  deletions.push(...store.statementsMatching(subject, predicate, null, doc));
  if (nextObject) {
    insertions.push((0, _rdflib.st)(subject, predicate, nextObject, doc));
  }
}

/* The following helper was generated by AI Model: GPT-5.3-Codex.
   Prompt: 'do you see anything I can do differently in the mutation code so that it's not so verbose and possible reusable accross sections' */
function collectLinkedNodeStatements(store, sourceNode, predicate, doc) {
  const linkedNodes = store.each(sourceNode, predicate, null, doc);
  const linkedStatements = linkedNodes.flatMap(linkedNode => collectNodeStatements(store, linkedNode, doc));
  const linkStatements = store.statementsMatching(sourceNode, predicate, null, doc);
  return {
    linkedNodes,
    linkedStatements,
    linkStatements
  };
}
function findExistingNode(nodes, entryNode) {
  const normalizedEntryNode = normalizeNodeId(entryNode);
  return nodes.find(node => {
    const nodeValue = normalizeNodeId(node.value);
    if (nodeValue === normalizedEntryNode) return true;
    return node.value === entryNode;
  });
}